import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { SUBMIT_BRIEF_ERROR, DEFAULT_PERSONALITIES_DATA } from './constants';

const serializeBriefData = ({ logo_name, brand_industry, brand_personality = DEFAULT_PERSONALITIES_DATA }) => ({
    logo_name: {
        brand_name: logo_name.brandName,
        slogan: logo_name.slogan
    },
    industries: brand_industry.industries,
    brand_values: {
        classic_or_modern: brand_personality.personalities.classic,
        accessible_or_luxurious: brand_personality.personalities.accessible,
        fun_or_serious: brand_personality.personalities.fun,
        simple_or_sophisticated: brand_personality.personalities.simple,
        innovative_or_established: brand_personality.personalities.established
    },
    description: brand_industry.business
});

/**
 * Returns brief samples
 * @returns {Promise<{pairs: Object[]}>}
 */
const submit = async({ briefId, briefData }) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'submitBrief' });
    const serializedBriefData = serializeBriefData(briefData);

    const response = await axios.post(requestUrl, { briefId, briefData: serializedBriefData })
        .then(({ data }) => data)
        .catch((response) => {
            logAPIError(response, { message: SUBMIT_BRIEF_ERROR, briefId, briefData });

            throw new Error(SUBMIT_BRIEF_ERROR);
        });

    return response;
};

export default submit;
